var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMultiEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 13.6 13.6",
    style: {
      enableBackground: "new 0 0 13.6 13.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7,5.7l1.8-1.1L6.8,1.1L1,4.6l1.8,1.1L1,6.8l1.8,1.1L1,9l5.8,3.5L12.6,9l-1.8-1.1l1.8-1.1L10.7,5.7z M2.5,4.6L6.8,2 l4.3,2.6L6.8,7.2L2.5,4.6z M11.1,9l-4.3,2.6L2.4,9l1.1-0.7l0,0l3.3,2l3.2-2L11.1,9z M6.8,9.4L2.4,6.8l1.1-0.7l0,0l3.3,2l3.2-2 l1.1,0.7L6.8,9.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiEditIcon);
export default __webpack_public_path__ + "static/media/multi-edit-icon.c5247eed37335422af1ef7b87d5de132.svg";
export { ForwardRef as ReactComponent };